/* eslint-disable react/prop-types */
/*

FOR MIGRATION ONLY

*/

// SAMPLE: /invoke/?apiName=authGetRes&todoId={{todo_id}}&decision=approved

import React from 'react';
import { Redirect } from 'react-router-dom';

function InvokeMigrate(props) {
  const { location: { search } } = props;

  const params = new URLSearchParams(search);
  const action = params.get('decision');
  const taskId = params.get('todoId');
  const urlPath = `/workflow/task/respond?taskId=${taskId}&action=${action}`;

  return <Redirect to={urlPath} />;
}

export default InvokeMigrate;
